"use client";

import { cn } from "@/lib/utils";
import { MapLocation } from "@/types/location";
import { locationIframeMap } from "@/lib/constants";

interface GoogleMapComponentProps {
  className?: string;
  locations: MapLocation[];
  activeLocationId?: string;
  mapId?: string;
  zoom?: number;
  darkMode?: boolean;
  src?: string; // Optional src for iframe fallback
}

export function GoogleMapComponent({
  className,
  locations,
  activeLocationId,
}: GoogleMapComponentProps) {
  // Find the active location
  const activeLocation =
    locations.find((loc) => loc.id === activeLocationId) || locations[0];

  return (
    <div className={cn("w-full h-full rounded-3xl overflow-hidden", className)}>
      <iframe
        key={activeLocation.id} // Force re-render when location changes
        src={
          locationIframeMap[
          (activeLocation.id as keyof typeof locationIframeMap) ?? "miami"
          ]
        }
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        title={`Map showing ${activeLocation.name} location`}
        allowFullScreen
      />
    </div>
  );
}
